
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/ai/[slug]",
      function () {
        return require("private-next-pages/project/ai/[slug]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/ai/[slug]"])
      });
    }
  